<template>
  <div class="flex flex-col gap-2 text-sm">
    <div class="flex items-baseline justify-between gap-3">
      <p class="min-w-0 truncate font-medium text-txmain">{{ item.label || `Публикация №${item.id}` }}</p>
      <span v-if="item.label" class="shrink-0 text-xs tabular-nums text-txsecondary">№{{ item.id }}</span>
    </div>
    <!-- Сводка одной фразой: «Размещение 23.09.2025, 20:29–21:29», без колонок -->
    <p v-if="item.status || item.fields?.length" class="text-[13px] leading-[1.45] text-txmain">
      <span
        v-if="item.status"
        class="mr-1.5 inline-block rounded-md px-2 py-px text-xs leading-[1.4]"
        :class="PUBLICATION_STATUS_CLASSES[item.status.tone]"
        >{{ item.status.text }}</span
      >
      <template v-for="(field, index) in item.fields" :key="field.label">
        <span v-if="index" class="text-txsecondary">{{ " · " }}</span>
        <span class="whitespace-nowrap"
          ><span v-if="field.labelInline" class="text-txsecondary">{{ `${field.label} ` }}</span
          >{{ field.value }}</span
        >
      </template>
    </p>
    <div v-if="hint" class="flex items-center gap-1.5 text-xs text-txsecondary">
      <IInfo class="size-3.5 min-w-3.5" />
      Нажмите, чтобы открыть публикацию
    </div>
  </div>
</template>

<script setup lang="ts">
  import IInfo from "~/components/order/adv/icons/IInfo.vue";
  import { PUBLICATION_STATUS_CLASSES, type PublicationMention } from "~/common/chatChannels";

  defineProps<{ item: PublicationMention; hint?: boolean }>();
</script>
